// extracted by mini-css-extract-plugin
module.exports = {"area":"NameAndLogout_area__1LSwO"};